const base = '/apiadmini/'
const storeGoodsSetApi = {
  add: base + 'backend/suppliers/setSuppliersGoodsHotelRule',
  detail: base + 'backend/suppliers/getSuppliersGoodsHotelRuleInfo'
}

export default storeGoodsSetApi
